import { Card, Tag } from "antd";
import { UserType } from "../../ducks/types";

type PropsType = {
  data: UserType | null;
};

export default function MyJobDetails(props: PropsType) {
  const { data } = props;
  return (
    <Card className="jobDetailsData">
      <div className="cardInfo">
        <h4>Job details</h4>
        <div className="profileWrapper">
          <div className="profileDetail">
            <div className="profileLabel">Position:</div>
            <div className="profileValue">
              <Tag className="red_tag">{data?.type?.replace("_", " ")}</Tag>
            </div>
          </div>
          <div className="profileDetail">
            <div className="profileLabel">Joined company:</div>
            <div className="profileValue">December 5, 2025</div>
          </div>
        </div>
      </div>
    </Card>
  );
}
